/**
 * Import all module depenencies here.
 * Add commonly used modules to externals.
 */
import core from '../app.core.module.js';
import loginConfig from './login.config.js';
import loginRoute from './login.route.js';
import loginController from './login.controller.js';
import loginService from './login.service.js';
import loginDataService from './login.data.service.js';

/**
 * This is the login module. It it the entry point for this website.
 * Only declare the module's dependencies in this file.
 * @namespace Login Module
 */
angular.module('login', [
  // Shared modules.
  core
])
// Register config.
.config(loginConfig)
// Register route.
.config(loginRoute)
// Register controller.
.controller('loginController', loginController)
// Register service.
.factory('loginService', loginService)
// Register data service.
.factory('loginDataService', loginDataService);

export default 'login';


// WEBPACK FOOTER //
// ./src/login/login.module.js